import api from "./api";

export const getHubWallet = async (hubId) => {
  const res = await api.get(`/wallet/${hubId}`);
  return res.data?.data ?? null;
};

export const getWalletTransactions = async (walletId) => {
  const res = await api.get(`/wallet/transactions/${walletId}`);
  const data = res.data?.data;
  return data?.$values ?? data ?? [];
};

export const requestPayout = async (userId, eventId) => {
  const res = await api.post("/payout", { userId, eventId });
  return res.data;
};

export const getEligiblePayoutEvents = async (userId) => {
  const res = await api.get(`/event/eligible-payouts?userId=${userId}`);
  const data = res.data?.data;
  return data?.$values ?? data ?? [];
};

export const getHubPayouts = async (hubId) => {
  const res = await api.get(`/payout`);
  const data = res.data?.data;
  return data?.$values ?? data ?? [];
};